__turbopack_context__.v({
  "accordionSlideOverwrite": "popover-module-scss-module__ZT3dWW__accordionSlideOverwrite",
  "fadeIn": "popover-module-scss-module__ZT3dWW__fadeIn",
  "fadeOut": "popover-module-scss-module__ZT3dWW__fadeOut",
  "popover": "popover-module-scss-module__ZT3dWW__popover",
  "scaleIn": "popover-module-scss-module__ZT3dWW__scaleIn",
  "scaleOut": "popover-module-scss-module__ZT3dWW__scaleOut",
  "zoomIn": "popover-module-scss-module__ZT3dWW__zoomIn",
  "zoomOut": "popover-module-scss-module__ZT3dWW__zoomOut",
});
